module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/audioplayselect/asset/playGifPng.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/audioplayselect/asset/playGifPng.png
// module id = 1075
// module chunks = 418